/**
 * Global configuration for GraphQL query limits and pagination
 */
export const QUERY_LIMITS = {
  // Main appointment queries
  APPOINTMENTS_DEFAULT: 200,
  APPOINTMENTS_CALENDAR: 200,
  APPOINTMENTS_HISTORY: 200,

  // Worker-specific queries
  WORKER_APPOINTMENTS_TODAY: 50,
  WORKER_APPOINTMENTS_UPCOMING: 20,

  // List views and pagination
  APPOINTMENTS_LIST_PAGE: 20,
  APPOINTMENTS_INCOMING: 20,
  APPOINTMENTS_WAITING_CONFIRM: 20,

  // Notifications
  NOTIFICATIONS_DEFAULT: 50,
  NOTIFICATIONS_UNREAD: 5,
  NOTIFICATIONS_BELL: 5,

  // Traffic sources and other entities
  TRAFFIC_SOURCES: 50,
} as const;

/**
 * Common sort configurations for appointments
 */
export const APPOINTMENT_SORT_CONFIG = {
  DEFAULT: {
    sortBy: "startTime" as const,
    sortOrder: "asc" as const,
  },
  REVERSE_CHRONOLOGICAL: {
    sortBy: "startTime" as const,
    sortOrder: "desc" as const,
  },
} as const;

/**
 * Polling intervals for real-time updates (in milliseconds)
 */
export const POLLING_INTERVALS = {
  APPOINTMENTS: 30000, // 30 seconds
  NOTIFICATIONS: 60000, // 1 minute
  DASHBOARD_METRICS: 30000, // 30 seconds
  CALENDAR: 30000, // 30 seconds
} as const;

/**
 * Cache policies for different query types
 */
export const CACHE_POLICIES = {
  APPOINTMENTS: {
    fetchPolicy: "cache-and-network" as const,
    errorPolicy: "all" as const,
  },
  NOTIFICATIONS: {
    fetchPolicy: "cache-first" as const,
    errorPolicy: "all" as const,
  },
  REAL_TIME: {
    fetchPolicy: "network-only" as const,
    errorPolicy: "all" as const,
  },
} as const;
